module.exports = __webpack_public_path__ + "img/置顶.9a959558.png";